import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import { initSentry } from "sentry";
initSentry();

import "helpers/setupDayjs";

import "@hotwired/turbo-rails";

import "controllers";

import "../stylesheets/application.scss";
import "../stylesheets/tailwind.css";
import "helpers/initTheme";

require.context("../images", true);

const dismissLoadingScreen = () => {
  const loadingScreen = document.getElementById("loading-screen");
  if (!loadingScreen) return;

  loadingScreen.classList.add("loaded");
  loadingScreen.addEventListener("transitionend", () => loadingScreen.remove());
};

if (document.readyState === "complete") {
  dismissLoadingScreen();
} else {
  window.addEventListener("load", dismissLoadingScreen);
}
